import { Component, h } from '@monygroupcorp/microact';

export class TransactionOptions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            nftMintingEnabled: props.nftMintingEnabled || false,
            message: props.message || '',
            isValid: props.isValid !== undefined ? props.isValid : true,
            nftBalance: props.nftBalance || 0,
            swapDirection: props.swapDirection || 'buy',
            lastValidationState: true,
            isPhase2: props.isPhase2 === null ? null : props.isPhase2
        };

        this.updateTimer = null;
    }

    didMount() {
        this.subscribe('contractData:updated', (data) => {
            const isPhase2 = data.liquidityPool && data.liquidityPool !== '0x0000000000000000000000000000000000000000';
            if (this.state.isPhase2 !== isPhase2) {
                this.setState({ isPhase2 });
            }
        });
    }

    validateTransaction() {
        const isMessageValid = this.state.message.length <= 140;
        const isNFTValid = !this.state.nftMintingEnabled || this.state.nftBalance < 10;
        const newIsValid = isMessageValid && isNFTValid;

        if (this.state.lastValidationState !== newIsValid) {
            this.setState({
                lastValidationState: newIsValid,
                isValid: newIsValid
            });

            this.props.eventBus?.emit('transactionValidation', {
                isValid: newIsValid,
                errors: this.getValidationErrors()
            });
        }
    }

    getValidationErrors() {
        const errors = [];

        if (this.state.message.length > 140) {
            errors.push('Message must be 140 characters or less');
        }

        if (this.state.nftMintingEnabled && this.state.nftBalance >= 10) {
            errors.push('Cannot mint more than 10 NFTs');
        }

        return errors;
    }

    handleMessageInput(e) {
        const newMessage = e.target.value || '';
        this.setState({ message: newMessage });
        this.validateTransaction();
        this.emitStateUpdate();
    }

    handleNFTToggle(e) {
        const isEnabled = e.target.checked;
        this.setState({ nftMintingEnabled: isEnabled });
        this.validateTransaction();
        this.emitStateUpdate();
    }

    emitStateUpdate() {
        const updatePayload = {
            message: this.state.message,
            nftMintingEnabled: this.state.nftMintingEnabled
        };
        this.props.eventBus?.emit('transactionOptions:update', updatePayload);
    }

    render() {
        const { nftMintingEnabled, message, isValid, isPhase2, swapDirection } = this.state;

        if (isPhase2 === null || isPhase2) {
            return h('div', { className: 'transaction-options empty' });
        }

        const errors = this.getValidationErrors();

        return h('div', { className: 'transaction-options' },
            h('div', {
                className: `option-group ${swapDirection === 'sell' ? 'hidden' : ''}`
            },
                h('label', { className: 'nft-toggle' },
                    h('input', {
                        type: 'checkbox',
                        checked: nftMintingEnabled,
                        onChange: this.bind(this.handleNFTToggle)
                    }),
                    'Mint NFT with transaction'
                )
            ),

            h('div', { className: 'option-group' },
                h('label', { htmlFor: 'messageInput' }, 'Transaction Message'),
                h('textarea', {
                    id: 'messageInput',
                    maxLength: 140,
                    placeholder: 'Enter optional message...',
                    value: message,
                    onInput: this.bind(this.handleMessageInput)
                }),
                h('span', {
                    className: `character-count ${message.length > 140 ? 'error' : ''}`
                }, `${message.length}/140`)
            ),

            h('div', {
                className: `validation-status ${isValid ? 'valid' : 'invalid'}`
            },
                errors.map((error, index) =>
                    h('p', { key: index, className: 'error' }, error)
                )
            )
        );
    }
}
